import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/Layout';
import { jwtDecode } from "jwt-decode";

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Login - DevWing'; // Update the document title
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOST}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem('jwt', data.token);

        // Decode the JWT to extract user roles
        const decodedToken = jwtDecode(data.token);
        const isAdmin = decodedToken.isAdmin || false;
        const isGod = decodedToken.isGod || false;
        const isOwner = decodedToken.isOwner || false;

        // Store roles in local storage
        if (isAdmin) {
          localStorage.setItem('isAdmin', isAdmin);
        }
        if (isGod) {
          localStorage.setItem('isGod', isGod);
        }
        if (isOwner) {
          localStorage.setItem('isOwner', isOwner);
        }

        // Store user data, ensuring organizations is always an array
        const userData = {
          ...data.user,
          organizations: data.user.organizations || []
        };
        localStorage.setItem('user', JSON.stringify(userData));

        toast.success('Login successful!');
        navigate('/dashboard');
      } else {
        const errorMessage = data.error || "An error has occurred, please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl text-center font-bold mb-8">Login</h1>
      <div className="max-w-prose mx-auto text-center"> 
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 border rounded-md"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border rounded-md"
          />
          <button type="submit" className="p-2 bg-sky-500 text-white rounded-md">
            Login
          </button>
          <div className="mt-4">
            <button
              onClick={() => navigate('/forgot-password')}
              className="text-sky-500 hover:underline"
            >
              Forgot Password?
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}

export default Login;
